import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Users
 * @type {function(type: string): {type: string, payload: any}}
 */
export const usersGetRequest = simpleAction(TYPES.USERS_GET_REQUEST);

/**
 * Request users success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const usersGetSuccess = simpleAction(TYPES.USERS_GET_SUCCESS);

/**
 * Request users error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const usersGetError = simpleAction(TYPES.USERS_GET_FAIL);

/**
 * Request User
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userLoadRequest = simpleAction(TYPES.USER_LOAD_REQUEST);

/**
 * Request User success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userLoadSuccess = simpleAction(TYPES.USER_LOAD_SUCCESS);

/**
 * Request User error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userLoadError = simpleAction(TYPES.USER_LOAD_FAIL);

/**
 * Create User
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userCreateRequest = simpleAction(TYPES.USER_CREATE_REQUEST);

/**
 * Create User Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userCreateSuccess = simpleAction(TYPES.USER_CREATE_SUCCESS);

/**
 * Create User Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userCreateError = simpleAction(TYPES.USER_CREATE_FAIL);

/**
 * Update User
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userUpdateRequest = simpleAction(TYPES.USER_UPDATE_REQUEST);

/**
 * Update User Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userUpdateSuccess = simpleAction(TYPES.USER_UPDATE_SUCCESS);

/**
 * Update User Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const userUpdateError = simpleAction(TYPES.USER_UPDATE_FAIL);
